import {Year} from './YearModel';

export const CURRENT_YEAR: Year = Number(
    new Intl.DateTimeFormat('default', {year: 'numeric'})
        .format(new Date())
);
